import { httpService } from './http'
const userRoute = 'handle-user/'


export const userService = {
    sendOTP,
    validateOTP,
    getUser,
    editUser,
    acceptInvite,
    rejectInvite,
}

window.userService = userService

async function sendOTP(email) {
    const confirm = await httpService.post(userRoute + 'login-otp', { email })
    return confirm
}

async function validateOTP(email, otp) {
    const user = await httpService.post(userRoute + 'validate-otp', { email, otp })
    return user
}

async function acceptInvite(teamId) {
    const invite = await httpService.put(userRoute + 'accept-invite', { teamId })
    return invite
}

async function rejectInvite(teamId) {
    const invite = await httpService.put(userRoute + 'reject-invite', { teamId })
    return invite
}

async function getUser() {
    const user = await httpService.get(userRoute + 'get-user')
    return user
}

async function editUser(change) {
    const confirm = await httpService.put(userRoute + 'edit-user', change)
    return confirm
}







